export enum EBonusWarnings {
  CANCEL = 'bonus-cancel',
  OVERRIDE = 'bonus-override',
  OVERRIDE_WELCOME_BONUS = 'welcome-bonus-override',
  ACCEPT_SPORT = 'accept-sport-bonus',
  OVERRIDE_COLLECTED_BONUS = 'override-collected-bonus',
}

export enum ERefillWarnings {
  BONUS_OVERRIDE = 'refill-bonus-override',
  BONUS_RESELECT = 'refill-bonus-reselect',
  ADDITIONAL_FIELDS = 'refill-additional-fields',
}

export interface IStickyDepositView {
  inViewDepositFirst;
  inViewDepositSecond;
  inViewDepositThird;
}

export enum ECurrency {
  EUR = '€',
  USD = '$',
  NOK = 'kr',
  BRL = 'R$',
  CAD = '$',
  JPY = '¥',
  PLN = 'zł',
  CHF = '₣',
  NZD = 'N$',
  RUB = '₽',
  DKK = 'kr',
  SEK = 'kr',
  CZK = 'Kč',
  HUF = 'Ft',
  AUD = 'A$',
}

export enum EPromoSlugs {
  WELCOME_PACK = 'welcome-package',
  TUESDAY_MYSTERY = 'tuesday-mystery',
  RELOAD = 'weekend-reload',
  LOYALTY = 'loyalty-programme',
  CASHBACK = 'weekly-cashback',
  SPORT_BONUS = 'sport-bonus',
}

export enum EPageSlugs {
  TERMS_AND_CONDITIONS = 'terms-and-conditions',
  SOURCE_OF_FUNDS_GUIDE = 'source-of-funds-guide',
  RESPONSIBLE_GAMING = 'responsible-gaming',
  PRIVACY_POLICY = 'privacy-policy',
  COOKIE_POLICY = 'cookie-policy',
  SPORT_WELCOME_BONUS_RULES = 'welcome-sports-terms',
  SPORT_BONUS_RULES = 'sports-bonus-terms',
  SPORT_BONUS_TERMS = 'welcome-package-sports-terms',
  CASINO_BONUS_TERMS = 'bonus-terms',
  SPORTBOOK_BETTING_GUIDE = 'sports-betting',
  TERMS_AND_CONDITIONS_ANJOUAN = 'terms-and-conditions-anjuoan',
  TERMS_AND_CONDITIONS_MIRROR = 'terms-and-conditions-mirror',
}

export enum IDropdownFlagTypes {
  NONE = 'none',
  PREFIX = 'byPrefix',
  CURRENCY = 'byCurrency',
  LANGUAGE = 'byLanguage',
  CODE = 'byCode',
  CUSTOM = 'byCustom',
  CODE_AND_PREFIX = 'byCodeAndPrefix',
}

export enum ETitles {
  REGISTER_TITLE = 'register_title',
  REGISTER_BTN_TEXT = 'register_btn_text',
  LOGIN_BTN_TEXT = 'login_btn_text',
  MOBILE_GET_STARTED_TITLE = 'mobile_get_started_title',
  MOBILE_GET_STARTED_SUBTITLE = 'mobile_get_started_subtitle',
  TOP_BANNER_TITLE = 'top_banner_title',
  TOP_BANNER_CREATE_ACCOUNT = 'top_banner_create_account',
  HOMEPAGE_INFO_BLOCK_BTN = 'homepage_info_block_btn',
  REPLAY_OVERLAY_OFFER_TITLE = 'replay_overlay_offer_title',
  REPLAY_OVERLAY_OFFER_BTN = 'replay_overlay_offer_btn',
  BOTTOM_BLOCK_TITLE = 'bottom_block_title',
  BOTTOM_BLOCK_BTN = 'bottom_block_btn',
  WELCOME_BONUS_TEXT = 'welcome_bonus_text',
  REGISTER_PROMO_TEXT = 'register_promo_text',
  SPORT_REGISTER_PROMO_TEXT = 'sport_register_promo_text',
  SPORT_DISABLED_REGISTER_PROMO_TEXT = 'sport_disabled_register_promo_text',
  SEARCH_PROMO_TEXT = 'search_promo_text',
  SPORT_BANNER_TITLE = 'sport_banner_title',
  SPORT_BANNER_DESCRIPTION = 'sport_banner_description',
}

export enum RegTypes {
  'EMAIL' = 'email',
  'DEPOSIT' = 'deposit',
  'PAYPLAY_T' = 'paynplay_t',
  'PAYPLAY_Z' = 'paynplay_z',
}

export const MONTH_KEYS = {
  1: 'month_january',
  2: 'month_february',
  3: 'month_march',
  4: 'month_april',
  5: 'month_may',
  6: 'month_june',
  7: 'month_july',
  8: 'month_august',
  9: 'month_september',
  10: 'month_october',
  11: 'month_november',
  12: 'month_december',
};

export const SOF_COUNTRIES = ['FI', 'EE', 'DK', 'SE']; // sof + sof guide link
export const HITZ_COUNTRIES = ['FI', 'EE', 'DK', 'SE']; // footer

export const recentSearchesLocalStorageId = 'recentSearches';
export const DEFAULT_LOCALE = 'en';

export const DEPLOY_ENVIRONMENT = {
  production: 'production',
  preprod: 'preprod',
  uat: 'uat',
  stg: 'stg',
  dev: 'dev',
  'preview-dev': 'preview-dev',
  'preview-prod': 'preview-prod',
};
